import React from 'react';
import { NavItem } from 'reactstrap';
import { FaFilePdf } from 'react-icons/fa';
import Menu from 'react-burger-menu/lib/menus/slide';

import './NnMenus.scss';

const NnPdfMenu = ({ displayLetters, notation, isOpen, onChange, onClose, onKeyDown, song }) => (
  <Menu
    id="pdf-menu"
    burgerButtonClassName="no-menu-button"
    crossButtonClassName="menu-close-button"
    menuClassName={'menu'}
    itemListClassName={'menu-item-list'}
    itemClassName={'menu-item'}
    customOnKeyDown={onKeyDown}
    isOpen={isOpen}
    onStateChange={onChange}
    right
    width={'60%'}
  >
    <ul>
      {['Lettered', 'Numbered'].map(notation => (
        <React.Fragment key={notation}>
          <li>
            <h1>{notation} Notation</h1>
          </li>
          {['Beginner', 'Intermediate', 'Advanced'].map(level => (
            <NavItem key={notation + level} onClick={onClose}>
              <a
                className="nav-link"
                href={song.pdfUrlFromSongId(notation, level)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFilePdf />
                {level} Sheet Music
              </a>
            </NavItem>
          ))}
        </React.Fragment>
      ))}
    </ul>
  </Menu>
);
export default NnPdfMenu;
